import styled from 'styled-components';
import { AlignCenter } from '../../../global/commonStyle';

const Main = styled.div`
  display: flex;
  flex-direction: column;
  .loading-animation {
    overflow: hidden;
  }
  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

const LoadingBox = styled.div`
  padding: var(--space-14) var(--space-12) var(--space-13);
  border-bottom: 0.5px solid var(--border-primary);
`;

const Loaddata = styled.div`
  display: flex;
  gap: var(--space-12);
  justify-content: space-between;
`;
const LeftLoading = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;

const RightLoading = styled.div`
  width: 38px;
  height: 8px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-6);
`;
const Left = styled.div`
  width: 30px;
  height: 30px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
`;

const Top = styled.div`
  width: 100px;
  height: 9px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-6);
`;

const Bottom = styled.div`
  width: 160px;
  height: 6px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-6);
`;

export { LoadingBox, Loaddata, LeftLoading, RightLoading, Left, Right, Top, Bottom, Main };
